/*!

=========================================================
* Light Bootstrap Dashboard React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {useLocation, Route, Switch, Redirect} from "react-router-dom";

import AdminNavbar from "components/Navbars/AdminNavbar";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";

import routes from "routes.js";

import sidebarImage from "assets/img/sidebar-3.jpg";
import Contract from "../views/admin/contract/Contract.js";
import ContractMake from "../views/admin/contract/ContractMake";
import UserProfile from "../views/UserProfile";
import ReferenceEdit from "../views/admin/reference/ReferenceEdit";
import CompleteContractMake from "../views/admin/completecontract/CompleteContractMake";
import CompleteContract from "../views/admin/completecontract/CompleteContract";

function Admin() {
  const [image, setImage] = React.useState(sidebarImage);
  const [color, setColor] = React.useState("black");
  const [hasImage, setHasImage] = React.useState(true);
  const location = useLocation();
  const mainPanel = React.useRef(null);
  const isLogin = sessionStorage.getItem("token");
  const getRoutes = (routes) => {
    if (isLogin) {


    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            render={(props) => <prop.component {...props} />}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
    } else {
      return <Redirect to="/login"/>
    }

  };
  React.useEffect(() => {

    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      var element = document.getElementById("bodyClick");
      element.parentNode.removeChild(element);
    }
  }, [location]);
  return (
    <>
      <div className="wrapper">
        <Sidebar color={color} image={hasImage ? image : ""} routes={routes} />
        <div className="main-panel" ref={mainPanel}>
          <AdminNavbar />
          <div className="content">
            <Switch>
              {getRoutes(routes)}
              <Route
                path="/admin/contractmake"
                render={props => <ContractMake {...props}/>}
              />
              <Route
                path="/admin/contract/:id"
                render={props => <Contract {...props}/>}
              />
              <Route
                path="/admin/completecontractmake"
                render={props => <CompleteContractMake {...props}/>}
              />
              <Route
                path="/admin/completecontract/:id"
                render={props => <CompleteContract {...props}/>}
              />
              <Route
                path="/admin/user/:id"
                render={props => <UserProfile {...props}/>}
              />
              <Route
                path="/admin/editreference/:id"
                render={props => <ReferenceEdit {...props}/>}
              />
            </Switch>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default Admin;
